import { Box, Checkbox, Icon, TableCell, TableRow, styled } from '@mui/material';
import { Card } from '@totalsoft/rocket-ui';
import FlexBox from 'components/common/FlexBox';
import { withPropsExclusion } from 'utils/functions';

export const CityHeaderRow = styled(
  TableRow,
  withPropsExclusion(['compact', 'inactive'])
)(({ theme, compact, inactive }) => ({
  '& td': {
    border: 'none',
    ...(compact && {
      paddingBlock: theme.spacing(0.75),
      ...(inactive && {
        color: theme.palette.grey[500]
      })
    })
  }
}));

export const CityEditCell = styled(TableCell)(() => ({
  padding: '0 !important'
}));

export const HierarchyContainer = styled(FlexBox)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.text.primary,
  '&:hover': {
    '& p, .MuiIcon-root': {
      color: theme.palette.primary.main
    }
  }
}));

export const HierarchyIcon = styled(Icon)(() => ({
  fontSize: '22px !important'
}));

export const DistrictContainer = styled(FlexBox)(() => ({
  height: '630px',
  width: '300px',
  borderRight: '1px solid rgba(224, 224, 224, 1)'
}));

export const DistrictsContainer = styled(FlexBox)(() => ({
  height: '630px'
}));

export const CitiesContainer = styled(FlexBox)(({ theme }) => ({
  overflowY: 'auto',
  overflowX: 'hidden',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2)
}));

export const DistrictRow = styled(
  TableRow,
  withPropsExclusion('inactive')
)(({ theme, inactive }) => ({
  cursor: 'pointer',
  '& td': {
    paddingBlock: theme.spacing(0.75),
    ...(inactive && {
      color: theme.palette.grey[500]
    })
  }
}));

export const CitySelectionCheckbox = styled(Checkbox)(() => ({
  padding: 0,
  '& .MuiSvgIcon-root': {
    width: '.85em',
    height: '.85em'
  }
}));

export const CityTableContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  flexShrink: 1,
  overflowY: 'auto',
  paddingRight: theme.spacing(1)
}));

export const DistrictsCitiesCard = styled(Card)(() => ({
  overflowX: 'auto'
}));

export const DistrictsCitiesContainer = styled(FlexBox)(() => ({
  minWidth: '900px'
}));
